import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

const useUsersConfiguration = storeId => {
  const {
    data: userGroups,
    loading: userGroupsLoading,
    fetchData: refetchUserGroups,
  } = useFetch(() => configurationServices.getUserGroups({ storeId }), {
    doInitialRequest: true,
  })

  const { fetchData: deleteUserGroup, loading: deletingUserGroup } = useFetch(configurationServices.deleteUserGroup, {
    doInitialRequest: false,
  })

  const { fetchData: deleteUser, loading: deletingUser } = useFetch(configurationServices.deleteUser, {
    doInitialRequest: false,
  })

  const { fetchData: resetUserPassword, loading: resettingUserPassword } = useFetch(
    configurationServices.resetUserPassword,
    {
      doInitialRequest: false,
    }
  )

  const { fetchData: migrateUserGroup, loading: migratingUserGroup } = useFetch(
    configurationServices.migrateUserGroup,
    {
      doInitialRequest: false,
    }
  )

  const { fetchData: getUsers, loading: usersLoading } = useFetch(configurationServices.getUsers, {
    doInitialRequest: false,
  })

  return {
    userGroups,
    userGroupsLoading,
    refetchUserGroups,
    deleteUser,
    deletingUser,
    resetUserPassword,
    resettingUserPassword,
    deleteUserGroup,
    deletingUserGroup,
    migrateUserGroup,
    migratingUserGroup,
    getUsers,
    usersLoading,
  }
}

export default useUsersConfiguration
